import { TransparentButton, Typography } from '@libs/components';
import styled from 'styled-components';

type CopyButtonType = {
  status: boolean;
  backgroundColor?: string;
};

export const CopyButton = styled(TransparentButton)<CopyButtonType>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.7rem 1.2rem;
  border-radius: ${({ theme }) => theme.borderRadius.highL};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? backgroundColor : theme.colors.interactive.brandColor};
`;

export const ImgContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CustomTypography = styled(Typography)`
  margin-right: 0.5rem;
`;
